import baseHttpService from "core/http/singleton/base";
import {
  getDetailNotifyIncomeUrl,
  getIncomeUrl,
  getListNotifyIncomeUrl,
  getVerifyOtpUrl,
  postSetupVerifyOtpUrl,
} from "./urls";
import type { IncomeDetailRes, IncomeOtpSectionRes } from "./resTypes";
import { getIncomeHttpConfig } from "./config";

function pickSection(data: IncomeDetailRes | IncomeOtpSectionRes): string {
  if ("section" in data && data.section) return data.section;
  if ("secretKey" in data && data.secretKey) return data.secretKey;
  return "";
}

/**
 * GET income — `getIncomeHttpConfig.requiresVerification` kích hoạt
 * `HttpClient`: chờ OTP → lưu section → request đi kèm header `X-Section`.
 */
export const getIncomeApi = async (): Promise<IncomeDetailRes> => {
  const res = await baseHttpService.get<IncomeDetailRes>(
    getIncomeUrl,
    {},
    getIncomeHttpConfig
  );
  if (!res?.data) throw new Error("Không lấy được dữ liệu thu nhập");
  return res.data;
};

/**
 * Đã có Google Authenticator — verify OTP (không gắn `requiresVerification`
 * để tránh mở lại modal).
 */
export const verifyIncomeOtpApi = async (
  otp: string
): Promise<IncomeOtpSectionRes> => {
  const res = await baseHttpService.get<IncomeDetailRes>(getVerifyOtpUrl(otp));
  if (!res?.data) throw new Error("Không xác thực được mã OTP");
  const section = pickSection(res.data);
  if (!section) throw new Error("Thiếu section token từ máy chủ");
  return { section };
};

/**
 * Cài đặt lần đầu — sau khi quét QR, gửi OTP để hoàn tất setup.
 */
export const setupIncomeOtpApi = async (
  otp: string
): Promise<IncomeOtpSectionRes> => {
  const res = await baseHttpService.post<IncomeDetailRes>(
    postSetupVerifyOtpUrl,
    { otp }
  );
  if (!res?.data) throw new Error("Không hoàn tất cài đặt xác thực");
  const section = pickSection(res.data);
  if (!section) throw new Error("Thiếu section token từ máy chủ");
  return { section };
};

export const getListNotifyIncomeApi = async (params) => {
  const { screen, ...rest } = params;
  const res = await baseHttpService.get(
    getListNotifyIncomeUrl(screen),
    rest,
    getIncomeHttpConfig
  );
  if (!res?.data) throw new Error("Không lấy được dữ liệu thu nhập");
  return res.data;
};

export const getDetailNotifyIncomeApi = async (params) => {
  const { screen, id } = params;
  const res = await baseHttpService.get(
    getDetailNotifyIncomeUrl(screen, id),
    {},
    getIncomeHttpConfig
  );
  if (!res?.data) throw new Error("Không lấy được dữ liệu thu nhập");
  return res.data;
};
